import { action, observable, runInAction } from "mobx";
import { api, apiOperacao } from "../../api";
import {
  ILog,
  ILogCienciaNsu,
  ILogWebServiceRequest,
} from "../../model";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _LogsStore {
  obs = observable({
    logs: [] as ILog[],
    currentPage: 1 as number,
    modalViewLog: false as boolean,
    acao: "" as string,
    processos: "" as string,
    dados: "" as string,
    data_log: null as Date,
    modalViewWait: false as boolean,
    logs_web_service: [] as ILogCienciaNsu[],
    modulo: "sistema" as string,
    component: "selecione" as string,
    filter: "" as string,
    filter_cnpj: "" as string,
    current_page: 1 as number,
    logs_length: 0 as number,
    detalhesLog: [] as any,
  })

  @action
  setCurrentPage(page: number) {
    this.obs.currentPage = page;
  }

  @action
  async filterLogWebServiceCiencia(
    cnpj: string,
    pagina: string,
    date1: string,
    date2: string,
  ) {
    try {
      let data: ILogWebServiceRequest = {
        empresa: cnpj,
        pagina: pagina,
        data1: date1,
        data2: date2,
      };

      let resp = await apiOperacao("logs").post(`/logs/ciencia`, data);

      this.obs.logs_web_service = [];

      if (resp.data.length > 0) {
        this.obs.logs_web_service = resp.data
      } else {
        toast.warning('Não há informações para serem exibidas.', {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao filtrar Log Web Service Ciencia, tente novamente mais tarde.`);
    }
  }

  @action
  async filterLogWebServiceNsu(
    cnpj: string,
    pagina: string,
    date1: string,
    date2: string,
  ) {
    try {
      let data: ILogWebServiceRequest = {
        empresa: cnpj,
        pagina: pagina,
        data1: date1,
        data2: date2,
      };

      let resp = await apiOperacao("logs").post(`/logs/nsu`, data);

      this.obs.logs_web_service = [];

      if (resp.data.length > 0) {
        this.obs.logs_web_service = resp.data
      } else {
        toast.warning('Não há informações para serem exibidas.', {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao filtrar Log Web Service Nsu, tente novamente mais tarde.`);
    }
  }

  @action
  public getCategoriaLogNsu(): string {
    return "WEB SERVICE DISTRIBUICAO NFE";
  }

  @action
  async filterLogs(date1: string, date2: string, component: string, page: number, filter: string) {
    try {

      const cnpj_format = (LogsStore.obs.filter_cnpj || "").replace(/[^0-9]/g, "")

      let params = {
        data_inicio: date1,
        data_fim: date2,
        modulo: this.obs.modulo,
        component: component,
        page: page,
        limit: 50,
        filter: filter,
        cnpj: cnpj_format
      }

      let resp = await apiOperacao("logs").post("/logs/index", params);

      this.obs.logs = [];
      this.obs.logs_length = 0;

      if (resp.data.itens.length > 0) {
        this.obs.logs = resp.data.itens
        this.obs.logs_length = resp.data.count;

      } else {
        toast.warning('Sem resultados', {});
      }

    } catch (ex) {
      toast_error(ex, `Erro ao filtrar Logs, tente novamente mais tarde.`);
    }
  }

}

export const LogsStore = new _LogsStore();
